import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { InternalAccesoService } from './internal-acceso.service';
import { Router } from '@angular/router';
import { UNAUTHORIZED, FORBIDDEN, LS_LANG, DEFAULT_LANG } from '../../../core/utils/constants';
import { MatDialog } from '@angular/material/dialog';
import { DialogsAlertComponent } from '../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';

@Component({
  selector: 'app-internal-acceso',
  templateUrl: './internal-acceso.component.html',
  styleUrls: ['./internal-acceso.component.scss']
})
export class InternalAccesoComponent implements OnInit {
  /** Booleano para mostrar o no el gif de cargar página */
  loading = false;
  loadingacceso = false;
  idioma = "";

  constructor(public internalAccesoService: InternalAccesoService,
              private router: Router,
              private translateService: TranslateService,
              private dialog: MatDialog) { }

  ngOnInit() {
    this.idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
    this.loadingacceso = true;
    this.internalAccesoService.initView().subscribe(res => {
        console.log(res);
        this.loadingacceso = false;
    }, error => {
        console.log("Error: " + error);
        this.loadingacceso = false;
        this.router.navigate(['/internal/acces']);
    });
  }

  /**
   * Se hace el acceso a la aplicación. Se llama al servicio para que envíe las credenciales al servidor
   */
  public submit(): void {
    this.loading = true; 
    // Se llama a doLogin del accesoService y se muestra error en pantalla si la respuesta es incorrecta
    this.internalAccesoService.doLogin().subscribe(res => {
      setTimeout(() => {
        if(res){
          this.router.navigate(['/internal/home']);
        }else{
          this.router.navigate(['/internal/acces']);
        }
        this.loading = false;
      }, 1000);
    }, error => {
      this.loading = false;
      this.showMsg(error);
      console.log("Error: " + error);
    });
  }

  /**
   * Muestra el mensaje de error correspondiente en caso de error o credenciales incorrectas al realizar el login
   * @param error Objeto de error. 401: Credenciales incorrectas, 403: Accesso incorrecto, Otro: Error en la autenticación
   */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
